import React,{useState} from 'react'
import AttendanceForm from './AttendanceForm';
import AttendanceListview from './AttendanceListview';


const Attendance = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <AttendanceForm addForm={setFromIsShown} update={upData} />
      ) : (
        <AttendanceListview addForm={setFromIsShown} update={setUpData} />
      )}

  </>
)
}

export default Attendance